import {SidebarMenuMain} from './SidebarMenuMain'
import clsx from "clsx";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

const SidebarMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate()

    const handleMenuClick = (option: "tag" | "strategy") => {
        if (option === "tag") {
            navigate("/tagManagement");
        } else if (option === "strategy") {
            navigate("/strategyManagement");
        }
        setMenuOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div id='#kt_aside_menu'
             data-kt-menu='true'
             className={clsx(
                 'w-full h-full flex flex-col justify-between menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500')}>
            <SidebarMenuMain/>
            <div style={{ position: "relative", display: "inline-block" }}>
                <button
                    className={"MoreButton"}
                    onClick={() => {
                        setMenuOpen((open) => !open);
                    }}
                >
                    <img alt="Logo" src="/media/icons/dots-horizontal.svg" className="w-4 h-4" />
                    More
                </button>
                                {menuOpen && createPortal(
                    <div
                        ref={menuRef}
                        style={{
                            position: "fixed",
                            left: "85px",
                            bottom: "20px",
                            background: "white",
                            borderRadius: 12,
                            boxShadow: "0px 15px 35px -5px rgba(31, 31, 31, 0.20), 0px 5px 15px 0px rgba(31, 31, 31, 0.08)",
                            padding: "6px 8px",
                            zIndex: 9999,
                            minWidth: 220,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                            pointerEvents: "auto"
                        }}
                    >
                        <button
                            className={"XSmallMediumText flex gap-[6px] items-center py-[10px] px-2"}
                            onClick={() => handleMenuClick("tag")}
                        >
                            <img src="/media/icons/tag.svg" alt="Tag" className={"w-4 h-4"}/>
                            Tag Management
                        </button>
                        <button
                            className={"XSmallMediumText flex gap-[6px] items-center py-[10px] px-2"}
                            onClick={() => handleMenuClick("strategy")}
                        >
                            <img src="/media/icons/strategy.svg" alt="Strategy" className={"w-4 h-4"} />
                            Strategy Management
                        </button>
                    </div>,
                    document.body
                )}
            </div>
        </div>
    );
}

export {SidebarMenu}
